import React from "react";
import { Route, Switch, useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import {
  ATTRIBUTES_SUB_URL,
  PUBLIC_TEST_URL,
  PERSONAL_SUMMARY_SUB_URL,
  SPECIAL_ATTRIBUTES_SUB_URL,
  MODULE_SUB_URL_PATTERN,
  INTRO_SUB_URL,
  END_SUB_URL,
  TOPIC_SELECTION_SUB_URL,
  JOURNEY_SUB_URL,
} from "../constants";
import {
  TestAttributes,
  ModuleIntro,
  StaticIntro,
  ModuleEnd,
  PersonalSummary,
  TestSet,
  TestSpecialAttributes,
  TestSetIntro,
  SolutionTopicSelection,
  SolutionJourney,
} from "./sub-pages";
import { UrlParams } from "./types";
import {
  useCssLinks,
  useTestIconAndTitle,
  useTestLanguage,
  usePublicTest,
} from "./hooks";

export function ParticipationFlow() {
  const { testId, sessionId } = useParams<UrlParams>();
  const {
    publicTest,
    isLoading,
    isRefetching,
    refetch: refetchTest,
  } = usePublicTest({ testId, sessionId });

  useCssLinks(publicTest);
  useTestLanguage(publicTest);
  useTestIconAndTitle(publicTest);

  if (isLoading && !isRefetching) {
    return <Loader />;
  }

  return (
    <Switch>
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/:module(intro)/:subPage`}
        component={StaticIntro}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/${INTRO_SUB_URL}`}
        component={ModuleIntro}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/${END_SUB_URL}`}
        component={ModuleEnd}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/${SPECIAL_ATTRIBUTES_SUB_URL}`}
        component={TestSpecialAttributes}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/${ATTRIBUTES_SUB_URL}`}
        component={TestAttributes}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/${PERSONAL_SUMMARY_SUB_URL}`}
        render={props => (
          <PersonalSummary {...props} refetchTest={refetchTest} />
        )}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/${TOPIC_SELECTION_SUB_URL}`}
        render={props => (
          <SolutionTopicSelection {...props} refetchTest={refetchTest} />
        )}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/${JOURNEY_SUB_URL}/:subStep`}
        component={SolutionJourney}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/:subPage/${INTRO_SUB_URL}`}
        component={TestSetIntro}
      />
      <Route
        exact
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/${MODULE_SUB_URL_PATTERN}/:subPage/:subStep`}
        component={TestSet}
      />
    </Switch>
  );
}
